import { render, staticRenderFns } from "./website-head.vue?vue&type=template&id=8888fe8e&scoped=true"
import script from "./website-head.vue?vue&type=script&lang=js"
export * from "./website-head.vue?vue&type=script&lang=js"
import style0 from "./website-head.vue?vue&type=style&index=0&id=8888fe8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8888fe8e",
  null
  
)

export default component.exports